// @ts-nocheck
document.addEventListener('DOMContentLoaded', function () {
  const buttonContainers = document.querySelectorAll('[data-product-virtual-class]');

  function updateVirtualClassButtons(productId, isInCart) {
    const allVirtualClassContainers = document.querySelectorAll(
      `[data-product-virtual-class][data-product-id="${productId}"]`,
    );

    allVirtualClassContainers.forEach((container) => {
      const productFormComponent = container.closest('product-form-component');
      const buyButtonsBlock = container.closest('.buy-buttons-block');

      const purchasedMessage = buyButtonsBlock?.querySelector('.virtual-class-purchased-message');
      const isAlreadyPurchased =
        purchasedMessage && purchasedMessage.textContent.trim() === 'You have already purchased this class.';

      if (isAlreadyPurchased) {
        if (productFormComponent) {
          productFormComponent.style.display = 'none';
        }
        if (purchasedMessage) {
          purchasedMessage.style.display = 'block';
        }
        const cartMessage = buyButtonsBlock?.querySelector('.virtual-class-in-cart-message');
        if (cartMessage) {
          cartMessage.remove();
        }
      } else if (isInCart) {
        if (productFormComponent) {
          productFormComponent.style.display = 'none';
        }
        if (buyButtonsBlock) {
          const existingMessage = buyButtonsBlock.querySelector('.virtual-class-in-cart-message');
          if (!existingMessage) {
            const message = document.createElement('p');
            message.className = 'virtual-class-in-cart-message';
            message.textContent = 'You have already added this class to your cart.';
            buyButtonsBlock.appendChild(message);
          }
        }
      } else {
        if (productFormComponent) {
          productFormComponent.style.display = 'block';
        }
        if (buyButtonsBlock) {
          const messageElement = buyButtonsBlock.querySelector('.virtual-class-in-cart-message');
          if (messageElement) {
            messageElement.remove();
          }
        }
      }
    });

    const customBuyButtonsContainers = document.querySelectorAll(
      `[data-product-virtual-class-container][data-product-id="${productId}"]`,
    );

    customBuyButtonsContainers.forEach((container) => {
      const purchasedMessage = container.querySelector('.virtual-class-purchased-message');
      const isAlreadyPurchased =
        purchasedMessage && purchasedMessage.textContent.trim() === 'You have already purchased this class.';

      if (isAlreadyPurchased) {
        const productFormComponent = container.querySelector('product-form-component');
        if (productFormComponent) {
          productFormComponent.style.display = 'none';
        }
        if (purchasedMessage) {
          purchasedMessage.style.display = 'block';
        }
        const cartMessage = container.querySelector('.virtual-class-in-cart-message');
        if (cartMessage) {
          cartMessage.style.display = 'none';
        }
      } else if (isInCart) {
        const productFormComponent = container.querySelector('product-form-component');
        if (productFormComponent) {
          productFormComponent.style.display = 'none';
        }

        const messageElement = container.querySelector('.virtual-class-in-cart-message');
        if (messageElement) {
          messageElement.style.display = 'block';
        }
      } else {
        const productFormComponent = container.querySelector('product-form-component');
        if (productFormComponent) {
          productFormComponent.style.display = 'block';
        }

        const messageElement = container.querySelector('.virtual-class-in-cart-message');
        if (messageElement) {
          messageElement.style.display = 'none';
        }
      }
    });
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }

  function handleRemoveButtonClick(e) {
    const target = e.target;
    const cartItem = target && typeof target.closest === 'function' ? target.closest('.c-cart-item') : null;
    const productId = cartItem && cartItem.dataset ? cartItem.dataset.productId : null;

    if (productId) {
      const allButtonContainers = document.querySelectorAll('[data-product-virtual-class]');

      allButtonContainers.forEach((container) => {
        const containerProductId = container.dataset ? container.dataset.productId : null;

        if (containerProductId === productId) {
          const productFormComponent = container.closest('product-form-component');
          const buyButtonsBlock = container.closest('.buy-buttons-block');

          const purchasedMessage = buyButtonsBlock?.querySelector('.virtual-class-purchased-message');
          const isAlreadyPurchased =
            purchasedMessage && purchasedMessage.textContent.trim() === 'You have already purchased this class.';

          if (isAlreadyPurchased) {
            if (productFormComponent) {
              productFormComponent.style.display = 'none';
            }
            if (purchasedMessage) {
              purchasedMessage.style.display = 'block';
            }
          } else {
            if (productFormComponent) {
              productFormComponent.style.display = 'block';
            }
          }

          if (buyButtonsBlock) {
            const messageElement = buyButtonsBlock.querySelector('.virtual-class-in-cart-message');
            if (messageElement) {
              messageElement.remove();
            }
          }
        }
      });

      const customBuyButtonsContainers = document.querySelectorAll('[data-product-virtual-class-container]');

      customBuyButtonsContainers.forEach((container) => {
        const containerProductId = container.dataset ? container.dataset.productId : null;

        if (containerProductId === productId) {
          const productFormComponent = container.querySelector('product-form-component');

          const purchasedMessage = container.querySelector('.virtual-class-purchased-message');
          const isAlreadyPurchased =
            purchasedMessage && purchasedMessage.textContent.trim() === 'You have already purchased this class.';

          if (isAlreadyPurchased) {
            if (productFormComponent) {
              productFormComponent.style.display = 'none';
            }
            if (purchasedMessage) {
              purchasedMessage.style.display = 'block';
            }
          } else {
            if (productFormComponent) {
              productFormComponent.style.display = 'block';
            }
          }

          const messageElement = container.querySelector('.virtual-class-in-cart-message');
          if (messageElement) {
            messageElement.style.display = 'none';
          }
        }
      });
    }
  }

  function handleUpsellButtonClick(e) {
    const button = e.target;
    const variantId = button.getAttribute('data-variant-id');

    const newbornClassContainers = document.querySelectorAll('[data-product-virtual-class]');
    let newbornClassProductId = null;

    newbornClassContainers.forEach((container) => {
      const productUrl = container.closest('[data-product-url]')?.getAttribute('data-product-url');

      if (productUrl && productUrl.includes('newborn-sleep-class')) {
        newbornClassProductId = container.getAttribute('data-product-id');
      }
    });

    if (newbornClassProductId) {
      const buyButtonsBlock = button.closest('.buy-buttons-block');
      const purchasedMessage = buyButtonsBlock?.querySelector('.virtual-class-purchased-message');
      const isAlreadyPurchased =
        purchasedMessage && purchasedMessage.textContent.trim() === 'You have already purchased this class.';

      if (!isAlreadyPurchased) {
        updateVirtualClassButtons(newbornClassProductId, true);
      }
    }

    openCartDrawer();
  }

  function checkCartStateAndUpdateButtons() {
    const cartItems = document.querySelectorAll('.c-cart-item');
    const cartProductIds = [];

    cartItems.forEach((item) => {
      const productId = item.dataset ? item.dataset.productId : null;
      if (productId) {
        cartProductIds.push(productId);
      }
    });

    buttonContainers.forEach((buttonContainer) => {
      const productId = buttonContainer.dataset ? buttonContainer.dataset.productId : null;
      if (productId) {
        const isInCart = cartProductIds.includes(productId);
        updateVirtualClassButtons(productId, isInCart);
      }
    });
  }

  function handleProductFormAdd(e) {
    const data = (e.detail && e.detail.data) || {};

    if (data.source !== 'product-form-component' || data.didError) return;

    const productId = data.productId;
    if (!productId) return;

    const buttonContainer = document.querySelector(`[data-product-virtual-class][data-product-id="${productId}"]`);
    if (!buttonContainer) return;

    const buyButtonsBlock = buttonContainer.closest('.buy-buttons-block');
    const purchasedMessage = buyButtonsBlock?.querySelector('.virtual-class-purchased-message');
    const isAlreadyPurchased =
      purchasedMessage && purchasedMessage.textContent.trim() === 'You have already purchased this class.';

    if (!isAlreadyPurchased) {
      updateVirtualClassButtons(productId, true);
    }

    openCartDrawer();
  }

  document.addEventListener('cart:update', handleProductFormAdd);

  document.addEventListener('click', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-product-virtual-class-remove')) {
      handleRemoveButtonClick(e);
    }

    if (e.target && e.target.classList && e.target.classList.contains('newborn-class-add-btn')) {
      handleUpsellButtonClick(e);
    }
  });

  checkCartStateAndUpdateButtons();

  setTimeout(checkCartStateAndUpdateButtons, 1000);

  document.addEventListener('cart:update', function () {
    setTimeout(checkCartStateAndUpdateButtons, 500);
  });
});
